
import { GalleryBlockModel } from 'fourwaves-shared';
import { Component, mixins } from 'nuxt-property-decorator';
import ContentBlockMixin from '../../ContentBlockMixin';
import GalleryBlockGrid from './GalleryBlockGrid.vue';

@Component({
  components: {
    GalleryBlockGrid,
  },
})
export default class GalleryBlock extends mixins(ContentBlockMixin<GalleryBlockModel>) {}
